import React from "react";
import SuccessStoryCarousel from "../../../components/SuccessStoryCarousel";
import { CARD_ITEMS } from "../../../constants/cardItems";

const SuccessStories = () => {
 
  return (
    <section className="py-16 bg-[#0F1338]">
      <div className="container mx-auto px-6 lg:px-4 ">
        <h2 className="text-3xl font-bold text-white text-center mb-4">
          Success Stories
        </h2>
        <p className="text-gray-200 text-center mb-12 max-w-2xl mx-auto">
          Hear from our satisfied customers who have transformed their audio
          experience with Audino
        </p>
        <SuccessStoryCarousel stories={CARD_ITEMS} />
      </div>
    </section>
  );
};

export default SuccessStories;
